import { connect } from 'react-redux';
import Stepper from './Stepper';

const mapStateToProps = state => ({
  step: state.simulation.step
});

export default connect(mapStateToProps)(Stepper);
